// registration-pages.ts
// import type { FC } from 'react';
// import type { PersonalDetailsProps, PaymentProps } from '@/components/features/registration/templates';

export const PersonalDetailsPages = {
   USERDETAILS: 'userDetails',
   GDPR: 'gdpr',
   PRIVACY_POLICY: 'privacyPolicy',
} as const;

export type PersonaDetailsPagesEnum = (typeof PersonalDetailsPages)[keyof typeof PersonalDetailsPages];

export const PersonalDetailsPageList: PersonaDetailsPagesEnum[] = Object.values(PersonalDetailsPages);

export const PaymentPages = {
   CARD_PREFERENCE: 'cardPreference',
   // SURVEY: 'survey',
   PAYMENT: 'payment',
} as const;

export type PaymentPagesEnum = (typeof PaymentPages)[keyof typeof PaymentPages];

export const PaymentPageList: PaymentPagesEnum[] = Object.values(PaymentPages);

export const KycPages = {
   KYC: 'kyc',
} as const;

export type KycPagesEnum = (typeof KycPages)[keyof typeof KycPages];

export const KycPageList: KycPagesEnum[] = Object.values(KycPages);

export const ApplicationVerificationPages = {
   APPLICATION_VERIFICATION: 'application-verification',
} as const;

export type ApplicationVerificationPagesEnum =
   (typeof ApplicationVerificationPages)[keyof typeof ApplicationVerificationPages];

export const ApplicationVerificationPageList: ApplicationVerificationPagesEnum[] =
   Object.values(ApplicationVerificationPages);
